import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { C, FONT, accountRootSx, eyebrowSx } from "../accountStyles";


export default function PaymentResult({ id, icon, title, children, action, closeTo, closeLabel = "Close", maxWidth = 600 }) {
  return (
    <Box sx={{ ...accountRootSx, bgcolor: C.soft, borderTop: `1px solid ${C.line}`, borderBottom: `1px solid ${C.line}`, px: 2, py: { xs: 6, md: 12 } }}>
      <Box
        component="section"
        aria-labelledby={id}
        sx={{ maxWidth, mx: "auto", p: { xs: 3, sm: 6 }, bgcolor: C.paper, border: `1px solid ${C.line}`, position: "relative", textAlign: "center" }}
      >
        <IconButton component={Link} to={closeTo} aria-label={closeLabel} sx={{ position: "absolute", top: 8, right: 8, color: C.secondary, borderRadius: 0 }}>
          <CloseIcon />
        </IconButton>

        {icon}

        <Typography sx={{ ...eyebrowSx, letterSpacing: "3px" }}>Payment</Typography>
        <Typography
          id={id}
          component="h1"
          sx={{ fontFamily: FONT, fontWeight: 400, fontSize: { xs: "1.75rem", md: "2.25rem" }, lineHeight: 1.2, color: C.ink, mt: 1 }}
        >
          {title}
        </Typography>

        <Box sx={{ mt: 3, mb: 5, mx: "auto", maxWidth: 460 }}>{children}</Box>

        {action}
      </Box>
    </Box>
  );
}
